import isPropValid from '@emotion/is-prop-valid';
import { styled } from 'styled-components';

export const BaseDiv = styled.div.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseButton = styled.button.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseHr = styled.hr.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseSpan = styled.span.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseImg = styled.img.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH1 = styled.h1.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH2 = styled.h2.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH3 = styled.h3.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH4 = styled.h4.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH5 = styled.h5.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseH6 = styled.h6.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseSvg = styled.svg.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseLabel = styled.label.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseLi = styled.li.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseUl = styled.ul.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseOl = styled.ol.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseInput = styled.input.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTextArea = styled.textarea.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTh = styled.th.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTd = styled.td.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTr = styled.tr.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTable = styled.table.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseThead = styled.thead.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTbody = styled.tbody.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseTfoot = styled.tfoot.withConfig({ shouldForwardProp: isPropValid })``;
export const BasePath = styled.path.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseRect = styled.rect.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseA = styled.a.withConfig({ shouldForwardProp: isPropValid })``;
export const BaseP = styled.p.withConfig({ shouldForwardProp: isPropValid })``;
